import React, { PropTypes } from 'react';
import { FlatButton } from 'material-ui';
import { propEq } from 'ramda';

const Buttons = props => {
  const {
    outerDivStyle,
    objectInfoToMap,
  } = props;

  return (
    <div style={outerDivStyle}>
      {
        objectInfoToMap.map((buttonInfo, index) => {
          return (
            <FlatButton
              key={index}
              label={buttonInfo.labelText}
              labelStyle={buttonInfo.labelStyle}
              style={buttonInfo.style}
              onTouchTap={buttonInfo.onTouchTap}
              primary={propEq('labelText', 'Cancel', buttonInfo)}
              secondary={propEq('labelText', 'Save', buttonInfo) || propEq('labelText', 'Next', buttonInfo)}
              disabled={propEq('labelText', 'Save', buttonInfo) || propEq('labelText', 'Next', buttonInfo) ? buttonInfo.disableButton : false}
            />
          );
        })
      }
    </div>
  );
};

Buttons.propTypes = {
  outerDivStyle: PropTypes.object,
  objectInfoToMap: PropTypes.array,
};

export default Buttons;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/send-to-partners/buttons.jsx